import { deepValue } from '@corratech/pylot-utils'
import { ProductInterface } from '@pylot-data/pylotschema'

export const getQuantity = (item: ProductInterface): string => {
    return deepValue(item, ['quantity'], 1)
}
